export enum Role {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_MANAGER = 'ROLE_MANAGER',
  ROLE_CLIENT = 'ROLE_CLIENT',
}
